import { alpha, darken } from '@mui/material/styles';

export function buildCardInfoContentPalette({ mode, brandMain, palette }) {
  const headerBg = mode === 'dark'
    ? darken(brandMain, 0.15)
    : brandMain;

  return {
    headerBg,
    headerText: '#ffffff',
    icon: '#ffffff',
    border: mode === 'dark' ? alpha('#ffffff', 0.15) : alpha('#000000', 0.08),
    shadow: mode === 'dark'
      ? '0 18px 40px rgba(0,0,0,0.55)'
      : '0 14px 32px rgba(128,0,0,0.2)',
    hoverShadow: mode === 'dark'
      ? '0 22px 48px rgba(0,0,0,0.65)'
      : '0 18px 42px rgba(128,0,0,0.28)',
    bg: palette.background.paper,
    contentText: palette.text.primary,
  };
}
